import { WriteProjectLimit } from "@/types/projectLimit";
import { z } from "@/zod";
import { ProjectLimitFormSchema } from "../schema";

type ProjectLimitForm = z.infer<typeof ProjectLimitFormSchema>;

interface DirtyFields {
  stores?: Record<
    string,
    Record<
      string,
      {
        hours?: boolean;
        rate?: boolean;
        addition?: boolean;
      }
    >
  >;
}

export const convertFormToWriteProjectLimit = (
  values: ProjectLimitForm,
  dirtyFields: DirtyFields,
): WriteProjectLimit => {
  const stores: WriteProjectLimit["stores"] = [];

  // Only process stores that have dirty fields
  Object.entries(dirtyFields.stores || {}).forEach(([storeId, departments]) => {
    const storeLimits: WriteProjectLimit["stores"][number]["limits"] = [];

    Object.entries(departments || {}).forEach(([departmentId, limits]) => {
      // If either hours or rate is dirty, include both values in the update
      if (limits?.hours || limits?.rate || limits?.addition) {
        const formValues = values.stores[storeId][departmentId];
        storeLimits.push({
          dependency_id: departmentId,
          hours: formValues.hours,
          rate: formValues.rate,
          addition: formValues.addition,
          entry_id: formValues.id,
        });
      }
    });

    if (storeLimits.length > 0) {
      stores.push({
        store_id: storeId,
        limits: storeLimits,
      });
    }
  });

  return {
    period: values.period,
    stores,
  };
};
